var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('popup', {
    attrs: {
      "opened": _vm.dataToShow !== ''
    },
    on: {
      "close": function ($event) {
        return _vm.changeToShow('');
      }
    }
  }, [_vm.dataToShow == 'areYouSure' ? _c('div', {
    staticClass: "mx-5 xl:mx-16 2xl:mx-20 my-8 w-auto h-auto"
  }, [_c('h3', {
    staticClass: "mb-10 text-pink-600"
  }, [_vm._v("Confirmation de suppression")]), _vm._v(" "), _c('h6', {
    staticClass: "text-indigo-600 mb-10"
  }, [_vm._v("\n      Êtes vous sûr de vouloir révoquer les droits du référent sur le Neopass\n      de " + _vm._s(_vm.beneficiaryReferentToEdit.firstname) + "\n      "), _c('span', {
    staticClass: "uppercase"
  }, [_vm._v(_vm._s(_vm.beneficiaryReferentToEdit.lastname))]), _vm._v("\n      ? "), _c('br'), _vm._v("\n      Cette suppression sera définitive et irrévocable.\n    ")]), _vm._v(" "), _c('div', {
    staticClass: "w-full flex justify-center"
  }, [_c('div', {
    staticClass: "mr-5"
  }, [_c('action-button', {
    staticClass: "relative flex flex-row",
    attrs: {
      "border-color": "border-pink-600",
      "text-color": "text-pink-600",
      "bg-color": "bg-pink-300",
      "libelle": "ANNULER"
    },
    on: {
      "clickAction": function ($event) {
        return _vm.changeToShow('');
      }
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "w-auto"
  }, [_c('action-button', {
    staticClass: "relative flex flex-row",
    attrs: {
      "border-color": "border-transparent",
      "text-color": "text-white",
      "bg-color": "bg-pink-600",
      "libelle": "SUPPRIMER",
      "type-shadow": "shadow-pink"
    },
    on: {
      "clickAction": function ($event) {
        return _vm.confirmDeleteBeneficiaryReferent();
      }
    }
  })], 1)])]) : _vm._e(), _vm._v(" "), _vm.dataToShow == 'detachSuccess' ? _c('div', {
    staticClass: "mx-5 xl:mx-16 2xl:mx-20 my-8 w-auto h-auto"
  }, [_c('h3', {
    staticClass: "text-indigo-600 mb-10"
  }, [_vm._v("\n      Le référent " + _vm._s(_vm.referentToEdit.firstname) + "\n      "), _c('span', {
    staticClass: "uppercase"
  }, [_vm._v(_vm._s(_vm.referentToEdit.lastname))]), _vm._v(" ne peut\n      plus gérer le carnet de parcours du bénéficiaire\n      " + _vm._s(_vm.beneficiaryReferentToEdit.firstname) + "\n      "), _c('span', {
    staticClass: "uppercase"
  }, [_vm._v(_vm._s(_vm.beneficiaryReferentToEdit.lastname))])]), _vm._v(" "), _c('div', {
    staticClass: "w-full flex justify-center"
  }, [_c('illustration', {
    staticClass: "w-full",
    attrs: {
      "name": "basket"
    }
  })], 1)]) : _vm._e()]);

}
var staticRenderFns = []

export { render, staticRenderFns }